import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./jserrorpage.module.scss";
// import SonicLink from "../../common/routing/SonicLink";

export const JSErrorPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["jserrorpage"]}>
      <h1 className={styles["jserrorpage_title"]}>
        {t("予期せぬエラーが\n発生しました")}
      </h1>
      <p className={styles["jserrorpage_text"]}>
        {t(
          "大変申し訳ございません。\n予期せぬエラーが発生しました。\n再度処理をお試しください。\n\n\n解決しない場合は、\n以下のボタンよりメールでご報告ください。"
        )}
      </p>
      <div className={styles["jserrorpage_maillink-wrapper"]}>
        <a
          href="mailto:contact-database@esports-select.com"
          className={styles["jserrorpage_maillink"]}
        >
          <i></i>
          <span className={styles["jserrorpage_maillink_text"]}>
            {t("エラー内容を報告する")}
          </span>
        </a>
      </div>
      {/* <div className={styles["jserrorpage_toplink-wrapper"]}>
        <SonicLink to="" className={styles["jserrorpage_toplink"]}>
          <span className={styles["jserrorpage_toplink_text"]}>
            {t("サイトTOPへ")}
          </span>
        </SonicLink>
      </div> */}
    </div>
  );
};

export default JSErrorPage;
